import DateRangePicker from "@/components/DateRangePicker";
import DebouncedInput from "@/components/DebouncedInput";
import SelectFilter from "@/components/SelectFilter";
import { SimpleGrid } from "@chakra-ui/react";
import { useCallback } from "react";
import { mapPayoutStatus } from "../mappers/payouts.mapper";
import type { AllPayoutsFiltersType } from "../types/payouts.type";

interface Props {
  queryFilters: AllPayoutsFiltersType;
  setQueryFilters: React.Dispatch<React.SetStateAction<AllPayoutsFiltersType>>;
}

export default function AllPayoutsFilters({
  queryFilters,
  setQueryFilters,
}: Props) {
  const handleDocumentNumberChange = useCallback(
    (value: string) =>
      setQueryFilters((prev) => ({
        ...prev,
        customerDocumentNumber: value || undefined,
      })),
    [setQueryFilters]
  );

  const handleBatchIdChange = useCallback(
    (value: string) =>
      setQueryFilters((prev) => ({ ...prev, batchId: value || undefined })),
    [setQueryFilters]
  );

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} gap={3} mb={4}>
      <DebouncedInput
        placeholder="Número de documento"
        size="sm"
        value={queryFilters.customerDocumentNumber}
        onDebouncedChange={handleDocumentNumberChange}
      />
      <DebouncedInput
        placeholder="ID de lote"
        size="sm"
        value={queryFilters.batchId}
        onDebouncedChange={handleBatchIdChange}
      />
      <DateRangePicker
        values={queryFilters.dateRange}
        setValues={(range) =>
          setQueryFilters((prev) => ({ ...prev, dateRange: range }))
        }
      />
      <SelectFilter
        isClearable
        options={Object.keys(mapPayoutStatus)}
        selectedOption={queryFilters.status}
        onSelect={(option) =>
          setQueryFilters((prev) => ({ ...prev, status: option }))
        }
        placeholder="Estado"
      />
    </SimpleGrid>
  );
}
